// Comprime una imagen del input a dataURL (máx 1024px por lado). Compartida entre el
// detalle de tareas y la página pública del puente QR (/evidencia/:token).
// Port del util de la agenda dental (F4 plan de tareas, 17-ago-2026).
// ⚠️ Safari/iOS y Firefox NO codifican webp en toDataURL: caen en silencio a PNG (enorme,
// ignora quality) — y el celular del puente QR es justo un iPhone típico. Por eso: se
// intenta webp, se VERIFICA el mime resultante y si no salió webp se usa JPEG (que Safari
// sí codifica con quality). Red final de tamaño: el body JSON del API topa ~1 MB.
const MAX_DATAURL = 900_000;
export function fileToDataUrl(file: File, max = 1024, quality = 0.8): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('No se pudo leer la imagen'));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error('Imagen inválida'));
      img.onload = () => {
        let { width, height } = img;
        const scale = Math.min(1, max / Math.max(width, height));
        width = Math.round(width * scale); height = Math.round(height * scale);
        const canvas = document.createElement('canvas');
        canvas.width = width; canvas.height = height;
        canvas.getContext('2d')!.drawImage(img, 0, 0, width, height);
        let dataUrl = canvas.toDataURL('image/webp', quality);
        if (!dataUrl.startsWith('data:image/webp')) dataUrl = canvas.toDataURL('image/jpeg', quality);
        for (const q of [0.6, 0.45, 0.3]) {
          if (dataUrl.length <= MAX_DATAURL) break;
          dataUrl = canvas.toDataURL('image/jpeg', q);
        }
        if (dataUrl.length > MAX_DATAURL) { reject(new Error('La imagen es demasiado grande incluso comprimida')); return; }
        resolve(dataUrl);
      };
      img.src = String(reader.result);
    };
    reader.readAsDataURL(file);
  });
}
